import React, { useState, useEffect } from "react";

function YelpSection() {
	const [reviews, setReviews] = useState([]);

	useEffect(() => {
		const fetchReviews = async () => {
			const apiKey = "YOUR_YELP_API_KEY";
			const businessId = "ORKIN_BUSINESS_ID"; // You need to replace this with the actual ID from Yelp
			const url = `https://api.yelp.com/v3/businesses/${businessId}/reviews`;

			try {
				const response = await fetch(url, {
					headers: {
						Authorization: `Bearer ${apiKey}`,
					},
				});
				if (!response.ok) {
					throw new Error("Could not fetch reviews");
				}
				const data = await response.json();
				setReviews(data.reviews);
			} catch (error) {
				console.error("Error fetching reviews:", error);
			}
		};

		fetchReviews();
	}, []);

	return (
      <div className="mt-12">
			<iframe
				src="https://b130e303ccef4fbaa82a96cad9a75c28.elf.site"
				style={{ width: "100%", height: "500px", border: "none" }}
				title="Yelp Widget"
        ></iframe>
		</div>
	);
}

export default YelpSection;
